export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11133.724dae76.jpg";